import React from 'react';
import Icon from '../../../components/AppIcon';

const FareInfoBox = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/20 rounded-lg p-4 md:p-5">
      <div className="flex items-start gap-3">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/20 rounded-lg flex-shrink-0">
          <Icon name="Banknote" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-3">
            Minibüs Ücretleri
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="flex items-center justify-between bg-background/50 rounded-lg p-3">
              <span className="text-sm text-muted-foreground">Minimum Ücret:</span>
              <span className="text-lg font-bold text-primary">35 TL</span>
            </div>
            <div className="flex items-center justify-between bg-background/50 rounded-lg p-3">
              <span className="text-sm text-muted-foreground">Uzun Mesafe:</span>
              <span className="text-lg font-bold text-primary">45 TL</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FareInfoBox;